import { z } from 'zod';

const runtimeConfigSchema = z.object({
  maintenanceBannerEnabled: z.boolean(),
});

const runtimeConfigResponseSchema = runtimeConfigSchema.partial();

export type RuntimeConfig = z.infer<typeof runtimeConfigSchema>;

export const defaultRuntimeConfig: RuntimeConfig = {
  maintenanceBannerEnabled: false,
};

export async function loadRuntimeConfig(fetchImpl: typeof fetch = fetch): Promise<RuntimeConfig> {
  const response = await fetchImpl('/runtime-config.json', { cache: 'no-store' });

  if (response.status === 404) {
    return defaultRuntimeConfig;
  }

  if (!response.ok) {
    throw new Error(`Failed to load runtime config: ${response.status}`);
  }

  const payload = runtimeConfigResponseSchema.parse(await response.json());

  return { ...defaultRuntimeConfig, ...payload };
}
